import { render } from "./BrandsView.vue?vue&type=template&id=4b578144&scoped=true"
import script from "./BrandsView.vue?vue&type=script&lang=js"
export * from "./BrandsView.vue?vue&type=script&lang=js"

import "./BrandsView.vue?vue&type=style&index=0&id=4b578144&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b578144"]])

export default __exports__